export const DOMAIN_ONLY_OFFICE = "ONLY_OFFICE";
